import type { Schemas } from '#shopware'
import { getTranslatedProperty } from '@shopware/helpers'

/**
 * Whether the category is shown in the flyout (desktop mega menu and mobile navigation).
 * Hidden are categories with `custom_category_hide_in_flyout` and brand categories that are not flagged as top brand.
 * The sidebar navigation does not use this and shows all categories of the main navigation response.
 */
export function isCategoryShownInFlyout(category: Schemas['Category']): boolean {
    const customFields = getTranslatedProperty(category, 'customFields') as Schemas['Category']['translated']['customFields']
    if (customFields?.custom_category_hide_in_flyout === true) return false

    return !customFields?.a4g_category_brand || customFields.a4g_category_brand_is_top_brand === true
}

/** Children of the category that are shown in the flyout */
export function getFlyoutChildren(category: Schemas['Category']): Schemas['Category'][] {
    return category.children?.filter(isCategoryShownInFlyout) ?? []
}
